import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo

//Import Components
import VerticalLayout from "./VerticalLayouts";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import assetURLs from "constants/assetURLs";
import ProfileDropdown from "Components/Common/ProfileDropdown";
import SidebarFooter from "./SidebarFooter";
import { useGetPartnerLogo } from "slices/auth/selector";

const Sidebar = ({ layoutType }: any) => {
  const partnerLogoUrl = useGetPartnerLogo();
  const hasPartnerLogo = typeof partnerLogoUrl === "string" && partnerLogoUrl.trim().length > 0;
  const logoSrc = hasPartnerLogo ? partnerLogoUrl : assetURLs.LOGO_WHITE;
  const logoSmHeight = 22;
  const logoLgHeight = hasPartnerLogo ? 55 : undefined;

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    };
  }
  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box text-start">
          <Link to="/" className="logo logo-dark w-100 h-100">
            <span className="logo-sm w-100 text-center">
              <img src={logoSrc} className={hasPartnerLogo ? "" : "ms-n2"} alt="" height={logoSmHeight} style={hasPartnerLogo ? { objectFit: "contain" } : undefined} />
            </span>
            <span className="logo-lg">
              <img src={logoSrc} alt="" className={hasPartnerLogo ? "" : "ms-1"} height={hasPartnerLogo ? logoLgHeight : 17} style={hasPartnerLogo ? { objectFit: "contain" } : undefined} />
            </span>
          </Link>

          <Link to="/" className="logo logo-light w-100 h-100">
            <span className="logo-sm w-100 text-center">
              <img src={logoSrc} className={hasPartnerLogo ? "" : "ms-n2"} alt="" height={logoSmHeight} style={hasPartnerLogo ? { objectFit: "contain" } : undefined} />
            </span>
            <span className="logo-lg">
              <img src={logoSrc} alt="" className={hasPartnerLogo ? "" : "ms-1"} height={hasPartnerLogo ? logoLgHeight : 35} style={hasPartnerLogo ? { objectFit: "contain" } : undefined} />
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="menu-height">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <SidebarFooter />
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
        {/* <ProfileDropdown /> */}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
